import person1 from "../../images/person1.jpg";
import person2 from "../../images/person2.jpg";
import person3 from "../../images/person3.jpg";
import person4 from "../../images/person4.jpg";
import person5 from "../../images/person5.jpg";
import person6 from "../../images/person6.jpg";

const HeroData = [
  {
    bg: "#FF6347",
    src: person1,
  },
  {
    bg: "#4682B4",
    src: person2,
  },
  {
    bg: "#8A2BE2",
    src: person3,
  },
  {
    bg: "#5F9EA0",
    src: person4,
  },
  {
    bg: "#D2691E",
    src: person5,
  },
  {
    bg: "#FF7F50",
    src: person6,
  },
];

export default HeroData;
